import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,DatePicker, 
  KeyboardDatePicker,
  DateTimePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { addDays } from "date-fns";
import Moment from 'react-moment';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';


let strbr=[{title:'',id:0}];

const headCells = [

  
  { id: 'ex_name', numeric: false, label: 'Name' },
  { id: 'ex_date', numeric: false, label: 'Date' },
  { id: 'ex_fromtime', numeric: false, label: 'From time' },
  { id: 'ex_totime', numeric: false, label: 'To time' },
  { id: 'ex_numofquestions', numeric: false, label: 'No. of questions' },
  { id: 'sb_title', numeric: false, label: 'Subject' },
  { id: 'ur_name', numeric: false, label: 'Teacher' },
  { id: 'tc_title', numeric: false, label: 'Class' },
  { id: 'br_title', numeric: false, label: 'Branch' },
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Exam extends Component {
	
    constructor(props) {
    super(props);
	const from = moment().startOf('month').toDate();
const to = moment().toDate();

let fmonth = (from.getMonth() + 1).toString().padStart(2, '0');
let fdate1 = from.getDate().toString().padStart(2, '0');
let fformatted = `${from.getFullYear()}-${fmonth}-${fdate1}`;
let tmonth = (to.getMonth() + 1).toString().padStart(2, '0');
let tdate1 = to.getDate().toString().padStart(2, '0');
let tformatted = `${to.getFullYear()}-${tmonth}-${tdate1}`;
   
      this.state = {redirect: false,
      Branchdata:[],exid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',titles:'',syllabus:'',brancharray:[],branch:'',rolelabel:'Select Branch',searchcustomer:'',sylabus:0,
	  fdate: from,
  tdate: to,subarra: [],subid:'',
  fdate1: fformatted,
  tdate1: tformatted,Classarr:[],classlabel:'Select Class', classid:'',yearid:localStorage.getItem("MMCyearid"),Yeararr:[],yearlabel:'Select Year',
      
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Branchdata:[]
    });
	
//this.componentDidMount();  
}
	
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}

	componentWillMount() { 
localStorage.setItem("pageactive",3)
}


	componentDidMount() {
	

	document.title = "MM Coching Center - Exam Management";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  this.onloadbranchbind();
  this.ClassBind();
  this.YearBind();
} 



 onloadbranchbind(){

   axios.get(Serverurl+'ajaxbranch.php?action=getall')
	
    
      .then((response) => {    
     
      this.setState({  brancharray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.brancharray.map(branch => {
                            
          return {value: branch.br_id, display:branch.br_title}
        });
      
		
        this.setState({
          brancharray: [{value: '0', display: 'Select branch'}].concat(roleFromApi)
        });
      })

} 

ClassBind()
{
axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
		
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

} 

YearBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=3')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Yeararr:resp.data,yearid:localStorage.getItem("MMCyearid")	
							}) 
			}
		
		//this.BatchBind();
	   }) .then(data => {
        let yearFromApi = this.state.Yeararr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Yeararr: yearFromApi
        });
      })

}
 

handfrChanges = (date) => {
	 
	 var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
     this.setState({ fdate:date,
fdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  
    
handtoChanges = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ tdate:date,
tdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }

handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
 if( this.state.subid!="0" && this.state.classid!="0")
	   {
		this.SubjectBind();
	   } 
}

apicall(page,rowsPerPage){
	 
	axios.get(Serverurl+'ajaxexam.php?action=getall&ex_name='+this.state.titles+'&ex_br_id='+this.state.branch+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&ex_class='+this.state.classid+'&ex_yearid='+this.state.yearid+'&ex_sb_id='+this.state.subid)
	
	//axios.get(Serverurl+'ajaxexam.php?action=getall&ex_name='+this.state.titles+'&ex_br_id='+this.state.branch+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&fromdate='+this.state.fdate1+ '&todate='+this.state.tdate1+'&ex_class='+this.state.classid)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Branchdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Branchdata:[],totaldata:0});
	 }
 
    });
}

handleChangePage = (event, newPage) => {
  this.setState({ page: newPage }, () => {
    this.apicall(newPage, this.state.rowsPerPage);
  });
};

handleChangeRowsPerPage = event => {
  const newRows = parseInt(event.target.value, 10);
  this.setState({
    page: 0,
    rowsPerPage: newRows,
  }, () => {
    this.apicall(0, newRows);
  });
};

  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      examDelete(exid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('ex_id',exid)
	 	   
	formData.append('userid',localStorage.getItem("MMCuserid"))
	
	
	 axios.post(Serverurl+"ajaxexam.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
      Examaddbox(val){
        this.setState({ exid: val });  
  
         setTimeout(() => this.refs.AddExambox.handleClickOpen(),500);

      }
  formatTime12H = (timeStr) => {
  if (!timeStr) return ""; 
  const [hour, minute, second] = timeStr.split(':');
  const date = new Date();
  date.setHours(hour);
  date.setMinutes(minute);
  date.setSeconds(second);

  return date.toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit', 
    //second: '2-digit', 
    hour12: true 
  });
}	  
SubjectBind()
{

	axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_class_id='+this.state.classid+'&sb_syllabustype='+this.state.sylabus)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						subarra:resp.data	
							}) 
			}
	
	
	   }) .then(data => {
        let classFromApi = this.state.subarra.map(row => {
                          
          return {value: row.sb_id, display:row.sb_title}
        });
      
		
        this.setState({
          subarra: [{value: '0', display: 'Select Subject'}].concat(classFromApi)
        });
      })
	  
	 
	  
}
handleSyllabusChange = (event) => {
 
	 
  let nam = event.target.name;
  let val = event.target.value;

	  
	   this.setState({[nam]: val,}, () => {
		   
		   
if(this.state.classid!="0" & this.state.sylabus!==0)
	   {
		  
 	this.SubjectBind();
	
	   }
});  
}
isExamLocked = (examDate, startTime, endTime) => {
  if (!examDate || !startTime || !endTime) return false;

  const datePart = examDate.split(" ")[0]; 

  const start = new Date(`${datePart}T${startTime}`);
  const end = new Date(`${datePart}T${endTime}`);
  const now = new Date();

  const tenMinutesBeforeStart = start.getTime() - 10 * 60 * 1000;

  return now >= tenMinutesBeforeStart; 
};


render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  

  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Exam Management</h2>
</div></div>

   <div className="searchmaster">


  
  <ul>

 <li><p>Name<span className="validationtxt"></span></p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.titles}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Exam Name"
            name="titles" onChange={this.myChangeHandler}
		
          /></p></li>
		
		
		  <li><p>Year<span className="validationtxt"></span></p>
	  <p>
	  <FormControl  fullWidth size="small" >
        
        <Select
         native
		 variant="outlined"
            margin="normal"
		 
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.yearid}
		  name="yearid"
		
		
        >
		{this.state.Yeararr.map(row => (
            <option  
            key={row.value}
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
			
			<li><p>Branch<span className="validationtxt"></span></p><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.branch }}
          onChange={this.myChangeHandler}
          id="branch"
		   value={this.state.branch}
		  name="branch"
		
		
        >
		{this.state.brancharray.map(branch => (
            <option  
            
              value={branch.value}
            >
              {branch.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			  </li>

	
	<li><p>Class<span className="validationtxt"></span></p>
	 <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	</li>
	
	{/*<li>
<p>From Date: <span className="validationtxt"></span></p>
 <p>
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
	 
      <DatePicker fullWidth
        value={this.state.fdate || addDays(moment().toDate(),1)}
        onChange={this.handfrChanges}
		
            format="dd/MM/yyyy"
        autoOk name="fdate"
        ampm={false} inputVariant="outlined"
      />
	   </Grid>
    </MuiPickersUtilsProvider>
		</p></li>
<li>
	<p>To Date: <span className="validationtxt"></span></p>
	  <p>
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
      <DatePicker fullWidth
        value={this.state.tdate || addDays(moment().toDate(),1)}
        onChange={this.handtoChanges}
		
            format="dd/MM/yyyy"
        autoOk name="tdate"
        ampm={false} inputVariant="outlined"
      />
	   </Grid>
    </MuiPickersUtilsProvider>
	
</p></li>*/}
	  <li><p><span className="validation">*</span> Syllabus Type</p>
	  <Radio
        checked={this.state.sylabus === '2'}
        onChange={this.handleSyllabusChange}
        value="2"
        name="sylabus"
        inputProps={{ 'aria-label': 'B' }}
      />State<Radio
        checked={this.state.sylabus === '1'}
        onChange={this.handleSyllabusChange}
        value="1"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />CBSE
    <Radio
        checked={this.state.sylabus === '3'}
        onChange={this.handleSyllabusChange}
        value="3"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />PUC

	  
	 </li>
	  {this.state.sylabus!==0 && (
	  
	  <li><p><span className="validation">*</span>Subject</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.subid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.subid}
		  name="subid"
		disabled={this.state.classid === "0" || this.state.classid === "" || this.state.sylabus === "0" || this.state.sylabus === ""}

		
        >
		{this.state.subarra.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li>
	  )}
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Examaddbox(0)}} className="frmsecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 
		
		
		
		
		</ul>
		
</div>		



<AddExambox ref="AddExambox" id={this.state.exid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Branchdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Branchdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.ex_name}</TableCell>
<TableCell><Moment format="DD-MM-YYYY">{item.ex_date}</Moment></TableCell>
<TableCell>{this.formatTime12H(item.ex_fromtime)}</TableCell>
<TableCell>{this.formatTime12H(item.ex_totime)}</TableCell>
<TableCell>{item.ex_numofquestions}</TableCell>
<TableCell>{item.sb_title}</TableCell>
<TableCell>{item.ur_name}</TableCell>
<TableCell>{item.tc_title}</TableCell>
<TableCell>{item.br_title}</TableCell>

<TableCell align="left">
<div className="actionbtns">


{!this.isExamLocked(item.ex_date, item.ex_fromtime, item.ex_totime) && (
  <>
    <Button 
      variant="contained" 
      className="frmPrimarybtn" 
      onClick={() => this.Examaddbox(item.ex_id)} 
      endIcon={<EditIcon />} 
    >
      Edit
    </Button>

    <Button 
      variant="contained" 
      className="admsndisablebtn" 
      onClick={() => this.examDelete(item.ex_id)} 
      endIcon={<DeleteIcon />} 
    >
      Delete
    </Button>
  </>
)}
{item.ex_isapproved === "1" && (
  <Button
    className="frmsecondarybtn"
    disabled
  >
    Approved
  </Button>
)}

 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
<TablePagination
  rowsPerPageOptions={this.state.rowsPaging}
  component="div"
  count={this.state.totaldata}
  rowsPerPage={this.state.rowsPerPage}
  page={this.state.page}
  onPageChange={this.handleChangePage}
  onRowsPerPageChange={this.handleChangeRowsPerPage}
/>
  
  </Paper>
    
</div>
 </React.Fragment> 

 
 
  );
}
}


export  class  AddExambox extends Component {

   constructor(props) {
      super(props)
	   this.dialogTopRef = React.createRef();
      this.state = {
		  
		   open:false,title:'',ex_id:0,brancharray:[],branch:'',rolelabel:'Select branch',
      errormessage:'',erropen:false,
	  brarrauto: [],    
  brarr: [],       sylabus:'', 
  branch: [],       
  branchSearch: '', ex_numofquestions:'',
  ex_date: null,
ex_fromtime: null,
ex_totime: null,ex_totime_disabled: false,
ex_timelimit: '',
ex_date_formatted: '',
ex_fromtime_formatted: '',subid:0,subarra: [],ts_ur_id:0,
ex_totime_formatted: '',
ex_mintime: '',
Classarr:[],classid:'0',classlabel:'Select Class',teacherarr:[],
	  }  
  }
  
  
  
  ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}
		
	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

	  

}
  
AutoBranchBind = () => {
  axios.post(Serverurl + 'ajaxbranch.php?action=branchextender&br_title=' + this.state.branchSearch)
    .then((resp) => {
      if (resp.data.length > 0) {
        const rowsArray = resp.data;
        let updatedArray = [...this.state.brarrauto];

        rowsArray.forEach((row) => {
          const item = { title: row.br_title, id: row.br_id };
          const exists = updatedArray.some(el => el.id === row.br_id);
          if (!exists) updatedArray.push(item);
        });

        this.setState({ brarrauto: updatedArray });
      } else {
        this.setState({ brarrauto: [] });
      }
    });
};




Examgetdata() {
  if (this.props.id !== 0) {
    axios.get(Serverurl + 'ajaxexam.php?action=getall&ex_id=' + this.props.id)
      .then(resp => {
        if (resp.data.length > 0) {
          const exam = resp.data[0];
          const selectedIds = exam.ex_br_id ? exam.ex_br_id.split(',') : [];

          axios.post(Serverurl + 'ajaxbranch.php?action=branchextender')
            .then((branchResp) => {
              const allBranches = branchResp.data;

              const selectedBranches = allBranches
                .filter(branch => selectedIds.includes(branch.br_id))
                .map(branch => ({
                  title: branch.br_title,
                  id: branch.br_id
                }));

              this.setState({
                brarrauto: allBranches.map(branch => ({
                  title: branch.br_title,
                  id: branch.br_id
                })),
				ex_id: exam.ex_id,
                brarr: selectedBranches,
                branch: selectedBranches.map(x => x.id),
                title: exam.ex_name,
                
  ex_date: moment(exam.ex_date).toDate(),
  ex_date_formatted: exam.ex_date,

  ex_fromtime: moment(exam.ex_fromtime, 'HH:mm').toDate(),
  ex_fromtime_formatted: exam.ex_fromtime,

  ex_totime: moment(exam.ex_totime, 'HH:mm').toDate(),
  ex_totime_formatted: exam.ex_totime,

  ex_timelimit: exam.ex_timelimit || '',
  ex_numofquestions: exam.ex_numofquestions,
  ex_mintime: exam.ex_mintime,
  classid: exam.ex_class,
  ts_ur_id: exam.ex_ts_id,
  subid: exam.ex_sb_id,
  sylabus: exam.ex_syllabus,
              },() => {
  this.SubjectBind();
  this.TeacherBind();
});
            });
        }
      });
  } else {
   
    this.setState({
      brarrauto: [],
      brarr: [],
      branch: [],
	  ex_date:'',
	  ex_date_formatted:'',
	  ex_fromtime:'',
	  ex_fromtime_formatted:'',
	  ex_totime:'',
	  ex_totime_formatted:'',
	  classid:'',
	  ts_ur_id:'',
	  subid:'',
	  sylabus:'',
	  ex_id:0,
	  
    });
    this.AutoBranchBind();
    this.ClassBind();
	this.TeacherBind();
    this.SubjectBind();
    
  }
}

handleDateChange = (date) => {
  const formatted = moment(date).format('YYYY-MM-DD');
  this.setState({
    ex_date: date,
    ex_date_formatted: formatted
  });
};

handleFromTimeChange = (time) => {
  const formatted = moment(time).format('HH:mm');
  this.setState({
    ex_fromtime: time,
    ex_fromtime_formatted: formatted
  }, () => {
    this.calculateToTime(); 
  });
};


handleToTimeChange = (time) => {
  const formatted = moment(time).format('HH:mm');
  this.setState({
    ex_totime: time,
    ex_totime_formatted: formatted
  });
};

   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  title:'',brancharray:[],branch:'',ex_date_formatted:'',ex_fromtime_formatted:'',ex_totime_formatted:'',ex_timelimit:'',ex_numofquestions:'',ex_mintime:'',
     errormessage:'',erropen:false,
	  });
		this.Examgetdata();
		this.AutoBranchBind();
		this.ClassBind();


};
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;

  this.setState({ [nam]: val }, () => {
    if (nam === 'ex_timelimit' && this.state.ex_fromtime) {
      this.calculateToTime(); 
    }

    this.SubjectBind();

    if ((nam === 'branch' || nam === 'subid')) {
      if (this.state.branch.length > 0 && this.state.subid && this.state.subid !== '0') {
        this.TeacherBind();
      } else {
        this.setState({ teacherarr: [{ value: '0', display: 'Select Teacher' }],ts_ur_id: '' });
      }
    }
  });
};


calculateToTime = () => {
  const { ex_fromtime, ex_timelimit } = this.state;

  if (ex_fromtime && ex_timelimit && !isNaN(ex_timelimit)) {
    const fromTimeMoment = moment(ex_fromtime);
    const newToTime = fromTimeMoment.add(parseInt(ex_timelimit), 'minutes');

    this.setState({
      ex_totime: newToTime.toDate(),
      ex_totime_formatted: newToTime.format('HH:mm'),
      ex_totime_disabled: true 
    });
  }
};

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	
 let title = this.state.title;
  let branch = this.state.branch;
  let ex_date_formatted = this.state.ex_date_formatted;
  let ex_fromtime_formatted = this.state.ex_fromtime_formatted;
  let ex_totime_formatted = this.state.ex_totime_formatted;
  let ex_timelimit = this.state.ex_timelimit;
  let ex_numofquestions = this.state.ex_numofquestions;
  let ex_mintime = this.state.ex_mintime;
  let classid = this.state.classid;
  let ts_ur_id = this.state.ts_ur_id;
  let subid = this.state.subid;
  



if(title==="")
{
	
	this.setState({errormessage:"Please Enter Exam Name",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}
if(branch==="")
{
	
	this.setState({errormessage:"Please Select Branch",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}
if(classid==="")
{
	
	this.setState({errormessage:"Please Select Class",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}
if (!ex_date_formatted || !ex_fromtime_formatted || !ex_totime_formatted) {
  this.setState({
    errormessage: "Please fill in all exam date/time fields.",
    erropen: true
  });
  this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
  return false;
}
if(ex_timelimit==="")
{
	
	this.setState({errormessage:"Please Enter Time Limit",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}
if(ex_numofquestions==="")
{
	
	this.setState({errormessage:"Please Enter Number of Questions",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}

if(ex_mintime==="")
{
	
	this.setState({errormessage:"Please Enter Minimum Submission Time",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}
if(subid==="")
{
	
	this.setState({errormessage:"Please Select",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}
if(ts_ur_id==="")
{
	
	this.setState({errormessage:"Please Select Teacher",erropen:true});
		 this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;
	
	
}

   var formData = new FormData();
   
   if(this.state.ex_id==0)
	  {
		  formData.append('ex_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('ex_id',this.state.ex_id)
		
          }
	  
        formData.append('action','insertorupdate') 
		
		formData.append('ex_name',title)
						
		formData.append('ex_br_id',branch)
formData.append('ex_date', this.state.ex_date_formatted);
formData.append('ex_fromtime', this.state.ex_fromtime_formatted);
formData.append('ex_totime', this.state.ex_totime_formatted);
formData.append('ex_timelimit', this.state.ex_timelimit);
formData.append('ex_numofquestions', this.state.ex_numofquestions);
formData.append('ex_mintime', this.state.ex_mintime);
formData.append('ex_class', this.state.classid) 
formData.append('ex_yearid', localStorage.getItem("MMCRegyearid")) 

		formData.append('userid',localStorage.getItem("MMCuserid"))
		formData.append('ex_ts_id', this.state.ts_ur_id);  
formData.append('ex_sb_id', this.state.subid);  
formData.append('ex_syllabus', this.state.sylabus); 

		  
		axios.post(Serverurl+"ajaxexam.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true
		});
		this.dialogTopRef.current?.scrollIntoView({ behavior: 'smooth' });
		 return false;

	}
  
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  
SubjectBind()
{

	axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_class_id='+this.state.classid+'&sb_syllabustype='+this.state.sylabus)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						subarra:resp.data	
							}) 
			}
	
	
	   }) .then(data => {
        let classFromApi = this.state.subarra.map(row => {
                          
          return {value: row.sb_id, display:row.sb_title}
        });
      
		
        this.setState({
          subarra: [{value: '0', display: 'Select Subject'}].concat(classFromApi)
        });
      })
	  
	 
	  
}
handleSyllabusChange = (event) => {
 
	 
  let nam = event.target.name;
  let val = event.target.value;

	  
	   this.setState({[nam]: val,}, () => {
		   
		   
if(this.state.sylabus!==0)
	   {
		  
 	this.SubjectBind();
	
	
	   }
});  
}

TeacherBind() {
  let branchid = '';
  let subid = '';

  if (this.state.branch && this.state.branch.length > 0) {
    branchid = this.state.branch[0];  
  }

  if (this.state.subid) {
    subid = this.state.subid;
  }

  if (!branchid || !subid || subid === '0') {
    this.setState({ teacherarr: [{ value: '0', display: 'Select Teacher' }] });
    return;
  }

  const formData = new FormData();
  formData.append('action', 'getteacherbybranchsub');
  formData.append('ts_br_id', branchid);
  formData.append('ts_sb_id', subid);

  axios.post(Serverurl + 'ajaxexam.php', formData)
    .then(resp => {
      if (Array.isArray(resp.data) && resp.data.length > 0) {
        const teacherOptions = resp.data.map(row => ({
          value: row.ts_ur_id || row.ur_id,
          display: row.ur_name
        }));

        this.setState({
          teacherarr: [{ value: '0', display: 'Select Teacher' }, ...teacherOptions]
        });
      } else {
        this.setState({
          teacherarr: [{ value: '0', display: 'Select Teacher' }]
        });
      }
    })

}



 
render (){

return(
<React.Fragment>
 
    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Exam </DialogTitle>
      <DialogContent>
	  
<div className="formlist" ref={this.dialogTopRef}>

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
				  
	<p> <span className="validation">*</span>Exam Name:</p>
	
	<p><TextField name="title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>	
						  
				
  <p><span className="validation">*</span> Branch</p>
  <p>
    <Autocomplete
      multiple
      style={{ width: '100%' }}
      fullWidth
      className="txtboxs"
      options={this.state.brarrauto}
      value={this.state.brarr}
      onChange={(event, newValue) => {
  this.setState({
    brarr: newValue,
    branch: newValue.map(item => item.id)
  }, () => {
    this.TeacherBind();
  });
}}

      onInputChange={(event, newInputValue) => {
        this.setState({ branchSearch: newInputValue }, () => {
          this.AutoBranchBind();
        });
      }}
      getOptionLabel={(option) => option.title}
      renderOption={(props, option) => (
        <li
          {...props}
          style={{
            opacity: this.state.brarr.some((v) => v.id === option.id) ? 0.5 : 1,
            pointerEvents: this.state.brarr.some((v) => v.id === option.id) ? 'none' : 'auto',
          }}
        >
          {option.title}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          placeholder="Search Branch"
        />
      )}
    />
  </p>
  
  
  <p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>

{this.state.classid !== '0' && this.state.classid !== '' && (
<>
<p><span className="validation">*</span> Syllabus Type</p>
	  <Radio
        checked={this.state.sylabus === '2'}
        onChange={this.handleSyllabusChange}
        value="2"
        name="sylabus"
        inputProps={{ 'aria-label': 'B' }}
      />State<Radio
        checked={this.state.sylabus === '1'}
        onChange={this.handleSyllabusChange}
        value="1"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />CBSE
    <Radio
        checked={this.state.sylabus === '3'}
        onChange={this.handleSyllabusChange}
        value="3"
        name="sylabus"
        inputProps={{ 'aria-label': 'A' }}
      />PUC

		<p></p>	
 {this.state.sylabus!==0 && (
	  <>
<p><span className="validation">*</span>Subject</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.subid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.subid}
		  name="subid"
		
		
        >
		{this.state.subarra.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	</>  )}</>
	
)}

{this.state.branch.length > 0 && this.state.subid && this.state.subid !== '0' && (
	 <>
<p><span className="validation">*</span>Teacher</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		  variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="ts_ur_id"
		  value={this.state.ts_ur_id}
		  name="ts_ur_id"
		
		
        >
		{this.state.teacherarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p></>
)}
<MuiPickersUtilsProvider utils={DateFnsUtils}>
  <p><span className="validation">*</span> Exam Date</p>
  <p>
    <KeyboardDatePicker
      margin="normal"
      format="dd-MM-yyyy"
      value={this.state.ex_date}
      onChange={this.handleDateChange}
      fullWidth
      inputVariant="outlined"
    />
  </p>
  
  <p><span className="validation">*</span>Time Limit(in minutes)</p>
<p>
  <TextField
    name="ex_timelimit" 
 type="number"	
    value={this.state.ex_timelimit}
    onChange={this.myChangeHandler}
placeholder="in minutes!" 
    fullWidth
  />
</p>

  <p><span className="validation">*</span> From Time</p>
  <p>
    <KeyboardTimePicker
      margin="normal"
      value={this.state.ex_fromtime}
      onChange={this.handleFromTimeChange}
      fullWidth
      inputVariant="outlined" minutesStep={5}
	  disableKeyboardInput 
    />
  </p>

  <p><span className="validation">*</span> To Time</p>
  <p>
    <KeyboardTimePicker
      margin="normal"
      value={this.state.ex_totime}
      onChange={this.handleToTimeChange}
      fullWidth
      inputVariant="outlined"
	  disabled
    />
  </p>
</MuiPickersUtilsProvider>


<p><span className="validation">*</span>No. of questions</p>
<p>
  <TextField
    name="ex_numofquestions" 
	type="number"	
    value={this.state.ex_numofquestions}
    onChange={this.myChangeHandler}
    fullWidth
  />
</p>

<p><span className="validation">*</span> Minimum submission time(in minutes)</p>
<p>
  <TextField
    name="ex_mintime" 
 type="number"	
    value={this.state.ex_mintime}
    onChange={this.myChangeHandler}
placeholder="in minutes!" 
    fullWidth
  />
</p>
		
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
	</div>		 
</DialogContent>
      
    </Dialog>
</React.Fragment>

) }
} 
  